export const ADD_TO_BASKET_CTA = 'Add to basket';
export const ADDING_TO_BASKET_CTA = 'Adding';
export const BUY_GIFT_CARD_CTA = 'Buy giftcard';
export const EDIT_PERSONALISATION_CTA = 'Save changes';
// Page CTA copy in edit mode; opens the drawer to amend existing options.
export const EDIT_YOUR_OPTIONS_CTA = 'Edit your options';
export const SAVING_PERSONALISATION_CTA = 'Saving';
// Page CTA copy when the product has options and the button opens the options drawer.
export const PERSONALISE_AND_BUY_CTA = 'Personalise & add to basket';
export const PICK_YOUR_OPTIONS_CTA = 'Customise & add to basket';
// Shown beneath the in-drawer CTA when required options are missing or invalid.
export const COMPLETE_REQUIRED_FIELDS_COPY = 'Complete all required fields to continue';
